import React from 'react';
import PropTypes from 'prop-types';
import { CheckBox, Sup } from 'Components';
import './EditColumnsListItem.css';

const EditColumnsListItem = ({ i, id, title, checked, handleToggle, onDragStart, isActive }) =>
  title ? (
    <li
      className={`edit-columns__list__item ${isActive ? 'edit-columns__list__item--active' : ''}`}
      draggable="true"
      onDragStart={onDragStart}
      data-id={i}
      data-key={id}
    >
      <CheckBox dataId={i} data-key={id} checked={checked} onClick={() => handleToggle(id, checked)} />
      <span data-id={i} data-key={id}>
        <Sup>{title}</Sup>
      </span>
    </li>
  ) : null;

EditColumnsListItem.propTypes = {
  onDragStart: PropTypes.func,
  handleToggle: PropTypes.func,
  i: PropTypes.number,
  id: PropTypes.string,
  title: PropTypes.string,
  checked: PropTypes.bool,
  isActive: PropTypes.bool,
};

EditColumnsListItem.defaultProps = {
  checked: false,
  isActive: false,
};

export default EditColumnsListItem;



// WEBPACK FOOTER //
// ./src/components/EditColumns/EditColumnsListItem/EditColumnsListItem.jsx